import { network } from 'services/network';

export const updateActivityCodeAlias = (params) => {
    return network.post('api/bo/updateActivityCodeAlias', params).then((response) => response.data);
};
